import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api';
import { KeyId } from '../types/public-api-settings-interface';
export const useDeleteKey = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.delete
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      deleteKey: async id => await fetcher(`${PUBLIC_API_SETTINGS}/${id}`)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};